export function getAIMemberData (mobile = false) {
  return {
    fixTip: {
      title: mobile
        ? '“AI 会员暖冬计划”，点击了解更多>>'
        : '“AI 会员暖冬计划”，聚焦 AI 技术，希望通过共学共创的方式，结合行业发展现状，帮助企业找到 AI 时代的业务新模式，点击了解更多>>>',
      url: 'https://ai.baidu.com/support/plan'
    },

    intro: {
      title: {
        word: 'AI 会员暖冬计划'
      },

      content: [
        '10 年前，TGO鲲鹏会成立 ，到现在累积会员超过 2000 名，持续助力中国互联网产业蓬勃发展。时间进入大模型时代，所有的企业需要数智化转型，所有的科技从业者需要具备 AI 能力，TGO鲲鹏会更不能缺席。借助 TGO鲲鹏会在全球各主要城市的影响力，极客俱乐部成立，肩负起普及 AI 技术的重任。希望通过线上课程学习、线下社群互助的方式，助力会员快速掌握 AI 技能，在职场里先人一步。'

      ]
    },

    model: {
      title: {
        word: '会员体系模式'
      },

      content: !mobile
        ? [
          'https://static001.geekbang.org/resource/image/8a/b0/8a2b9a44be730a0d9e919fe5f772a7b0.png',
          'https://static001.geekbang.org/resource/image/48/7a/48d54ba1ed002e879b20fc5e1345e87a.png'
        ]
        : [
          'https://static001.geekbang.org/resource/image/40/9a/40497476f9ceecd198yy3d31d690479a.png',
          'https://static001.geekbang.org/resource/image/57/bf/570e77d66925cd9676815449ef088fbf.png',
          'https://static001.geekbang.org/resource/image/a7/04/a7e87d27368c02f9yy8f9f51ebc26b04.png'
        ]
    },

    fixMember: {
      content: [
        {
          title: 'TGO 鲲鹏会',
          icon: 'https://static001.geekbang.org/resource/image/18/7f/18a113e2c3fee1ba9eb187e32609767f.png',
          url: 'https://tgo.infoq.cn/apply'
        },
        {
          title: '极客俱乐部',
          icon: 'https://static001.geekbang.org/resource/image/df/4c/df8584754d16a9a8e710a6dfdd1d014c.png',
          jumpType: 'modal'
        }
      ]
    },

    question: [
      {
        q: 'Q：什么是“同侪学习小组”？',
        a: 'TGO鲲鹏会的旗舰产品，一般是 8-10 人，由非利益相关会员组成，通过每月一次线下至少 4 个小时的结构化私享讨论，共同成长。'
      },
      {
        q: 'Q：什么是“闭门研讨会”？',
        a: 'TGO鲲鹏会产品，通过针对某一个主题的深入结构化研讨，以共创的方式，帮助会员解决工作或者生活过成中遇到的挑战，共同找到适合的答案。'
      },
      {
        q: 'Q：什么是“极客时间企业账号”？',
        a: '极客邦科技推出的面向企业科技人员的线上学习产品，通过在线课程的方式提升数字化能力，通常每人一个学习账号，形成自己的学习数字资产。'
      },
      {
        q: 'Q：什么是“会员线下活动”？',
        a: '由当地 TGO鲲鹏会或极客俱乐部发起组织的活动，通常每月一次，包括个人领导力、技术创新力、业务理解力等不同话题的学习。举例，在 TGO鲲鹏会，AGI 共学营、亲子活动、禅修营饱受欢迎。'
      },
      {
        q: 'Q：什么是“系列专题大课”？',
        a: '一般是由极客邦科技官方发起，协同TGO鲲鹏会或极客俱乐部举办，基于当前会员或行业需求组织活动，比如产品战略专家梁宁全球巡讲，技术战略专家乔新亮全球巡讲等。'
      },
      {
        q: 'Q：什么是“极客游学”？',
        a: '一般是由极客邦科技官方发起，协同 TGO鲲鹏会或极客俱乐部举办，走访知名企业、组织、国际顶尖会议等，比如蔚来汽车游学、乌镇世界互联网大会游学、AWS re:Invent游学等。'
      },
      {
        q: 'Q：什么是“InfoQ 技术大会”？',
        a: '由极客邦科技旗下媒体社区 InfoQ 举办的年度技术大会，包括 QCon 全球软件开发大会，AICon 全球人工智能开发与应用大会，GTLC 全球科技领导力大会等。'
      },
      {
        q: 'Q：什么是“极客时间训练营”？',
        a: '由极客邦科技旗下学习平台极客时间组织的，针对某个技术专题的学习产品，通常持续 3~6 个月，包括 Rust 训练营、大模型训练营等，帮助学员真正掌握某一门技术。'
      },
      {
        q: 'Q: 什么是“会员盲盒”？',
        a: '由 TGO鲲鹏会和极客俱乐部不定期提供的实物产品，包括热门书籍、研究报告、周边产品等，期望通过一种方式建立组织和会员之间的物理连接。'
      },
      {
        q: 'Q：什么是“不定期线上直播”？',
        a: '为 TGO鲲鹏会和极客俱乐部会员提供的线上学习产品，针对会员需求，邀请合适的专家，通过线上的方式提供知识分享，一般会有直播回放。'
      },
      {
        q: 'Q：什么是“极客时间课程学习”？',
        a: '这里指极客时间 VIP，是极客时间推出的年度会员权益，用户开通会员后在会员有效期内，可以学习站内所有课程，包括 InfoQ 技术大会视频内容。'
      }
    ]
  }
}
